import * as React from "react";

const SearchIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 14 14"
  >
    <g stroke="#62748E">
      <path d="m10.208 10.208 2.625 2.625M11.667 6.417a5.25 5.25 0 1 0-10.5 0 5.25 5.25 0 0 0 10.5 0Z"></path>
    </g>
  </svg>
);

export default SearchIcon;

export const SearchIcon2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8.217 13.304a5.87 5.87 0 1 0 0-11.739 5.87 5.87 0 0 0 0 11.74Z"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
      d="M10.688 5.612a3.12 3.12 0 0 0-2.213-.916 3.12 3.12 0 0 0-2.214.916"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m12.217 13 3.32 3.32"
    ></path>
  </svg>
);
